import { IGameEventConfig, IRegistrationStep } from '../events';

const REGISTRATION_STEPS: IRegistrationStep[] = [];

export const WOWERA_EVENT_CONFIG: IGameEventConfig = {
  registrationSteps: REGISTRATION_STEPS
};
